// @generated by protoc-gen-es v1.2.0
// @generated from file ethermint/types/v1/web3.proto (package ethermint.types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * ExtensionOptionsWeb3Tx is an extension option that specifies the typed chain id,
 * the fee payer as well as its signature data.
 *
 * @generated from message ethermint.types.v1.ExtensionOptionsWeb3Tx
 */
export const ExtensionOptionsWeb3Tx = proto3.makeMessageType(
  "ethermint.types.v1.ExtensionOptionsWeb3Tx",
  () => [
    { no: 1, name: "typed_data_chain_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "fee_payer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "fee_payer_sig", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

